import { fromJS } from 'immutable'
import _get from 'lodash/get'
import {
  get as apiGet,
  TYPE_BROOKLYN_JSON,
  RESPONSE_ERROR_TYPE_RANGE_500,
} from '../../api-client/index'

export const PAYMENT_PROVIDER_NAME_GCSI = 'gcsi'
export const PAYMENT_PROVIDER_NAME_ZUORA = 'zuora'

function handleResponse (res) {
  return fromJS({
    lastTransaction: _get(res, 'body', {}),
  })
}

export default async function getPaytrackLastTransaction (options = {}) {
  const { auth } = options

  if (!auth) {
    return handleResponse({})
  }

  const apiOptions = {
    auth,
    responseErrorType: RESPONSE_ERROR_TYPE_RANGE_500,
  }
  const res = await apiGet('/last-transaction', null, apiOptions, TYPE_BROOKLYN_JSON)
  return handleResponse(res)
}
